import {
  RiMailLine,
  RiMessage2Line,
  RiWhatsappLine,
  RiTimeLine,
} from "react-icons/ri";

const RecentActivity = () => {
  const activities = [
    {
      id: 1,
      type: "email",
      icon: RiMailLine,
      message: "Monthly newsletter sent to 2,500 subscribers",
      time: "2 hours ago",
      status: "success",
    },
    {
      id: 2,
      type: "whatsapp",
      icon: RiWhatsappLine,
      message: "Promotional campaign delivered to 500 customers",
      time: "4 hours ago",
      status: "success",
    },
    {
      id: 3,
      type: "sms",
      icon: RiMessage2Line,
      message: "Event reminder sent to 150 attendees",
      time: "6 hours ago",
      status: "warning",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "success":
        return "bg-success-50 text-success-700";
      case "warning":
        return "bg-warning-50 text-warning-700";
      case "error":
        return "bg-danger-50 text-danger-700";
      default:
        return "bg-secondary-50 text-secondary-700";
    }
  };

  return (
    <div className="card">
      <h2 className="text-xl font-semibold text-secondary-900 mb-4">
        Recent Activity
      </h2>
      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-start space-x-4">
            <div
              className={`p-2 rounded-lg ${getStatusColor(activity.status)}`}
            >
              <activity.icon className="w-5 h-5" />
            </div>
            <div className="flex-1">
              <p className="text-secondary-900">{activity.message}</p>
              <div className="flex items-center mt-1 text-sm text-secondary-600">
                <RiTimeLine className="w-4 h-4 mr-1" />
                {activity.time}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;
